import { Modal } from "antd";
import styles from "./VideoModal.module.scss";
import { Icon } from "../icon";
import { useIsMobile } from "~/hooks";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoSrc: string;
}

export const VideoModal = ({ isOpen, onClose, videoSrc }: VideoModalProps) => {
  const isMobile = useIsMobile();

  const isLocalImport =
    videoSrc.startsWith("/assets/") || videoSrc.startsWith(import.meta.env.BASE_URL);
  const isSafeVideoSrc = isLocalImport || videoSrc.startsWith(window.location.origin);

  if (!isSafeVideoSrc) return null;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={900}
      closable={false}
      destroyOnClose
      styles={{
        content: {
          padding: isMobile ? "24px" : "40px"
        }
      }}
    >
      <div className={styles.videoContainer}>
        <video
          controls
          autoPlay
          playsInline
          preload="metadata"
          className={styles.video}
          src={videoSrc}
        >
          Ваш браузер не поддерживает видео.
        </video>
      </div>
      <Icon name="close" className={styles.iconClose} onClick={onClose} />
    </Modal>
  );
};
